export function formatPhoneNumber(phoneNumberString: string): string {
    try {
        if (phoneNumberString) {
            const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                const intlCode = (match[1] ? "+1 " : "");
                return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
            }
        }
    } catch (err) {
        // ignore the error
    }
    return phoneNumberString;
}

export function formatTitleCase(str: string): string {
    try {
        if (str) {
            const strings = str.toLowerCase().split(" ");
            for (let i = 0; i < strings.length; i++) {
                strings[i] = (strings[i].length > 0 ? strings[i].charAt(0).toUpperCase() : "") + strings[i].slice(1);
            }
            return strings.join(" ");
        }
    } catch (err) {
        // ignore the error
    }
    return str;
}

export function parseAddress(address: string): { street1: string, street2?: string, city: string, state: string, zip: string} {
    if (!address) return null;

    const split: Array<string> = address.split(",");
    if (split.length === 4) {
        return {
            street1: split[0].trim(),
            city: split[1].trim(),
            state: split[2].trim(),
            zip: split[3].trim()
        };
    } else if (split.length === 5) {
        return {
            street1: split[0].trim(),
            street2: split[1].trim(),
            city: split[2].trim(),
            state: split[3].trim(),
            zip: split[4].trim()
        };
    }
    return null;
}

export function validEmail(email: string) {
    const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return regexp.test(email);
}

export function validName(name: string) {
    const regexp = new RegExp(/\w+\s+\w+.*/);
    return regexp.test(name);
}

export function validPhone(phone: string) {
  const regexp = new RegExp(/^[+]?\d*$/);
  return regexp.test(phone);
}

export function deepEquals(o1: any, o2: any): boolean {
    return JSON.stringify(o1) === JSON.stringify(o2);
}
